import {Customer} from '../master-data/master-data.model';

export class Chain{
  uuid: string;
  name: string;
  externalId: string;
  customers: Customer[];
}

export class CreateChainCommand {
  name: string;
  customerUuids: string[];
  externalId: string;
}

export class ChangeChainCommand {
  chainUuid: string;
  name: string;
  customerUuids: string[];
  externalId: string;
}

